import { TranslateService } from 'ng2-translate';

export const taixiuFace = (translate: TranslateService) => [
    {
        isdefault: true,
        title: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.TITLE'),
        label: [
            {
                subIDFace: 'txcl',
                description: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.DESCRIPTION'),
                ratio: '1:0.98'
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('TAIXIU_FACE.BO_DOI_DONG_NHAT.TITLE'),
        label: [
            {
                subIDFace: 'bddn',
                description: translate.instant('TAIXIU_FACE.BO_DOI_DONG_NHAT.DESCRIPTION'),
                ratio: '1:10'
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('TAIXIU_FACE.BO_BA_DONG_NHAT.TITLE'),
        label: [
            {
                subIDFace: 'bbdn',
                description: translate.instant('TAIXIU_FACE.BO_BA_DONG_NHAT.DESCRIPTION'),
                ratio: '(1:180) - (1:30)'
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('TAIXIU_FACE.CUOC_TOAN.TITLE'),
        label: [
            {
                subIDFace: 'ct',
                description: translate.instant('TAIXIU_FACE.CUOC_TOAN.DESCRIPTION'),
                ratio: '(1-60)'
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('TAIXIU_FACE.CUOC_CAP.TITLE'),
        label: [
            {
                subIDFace: 'cc',
                description: translate.instant('TAIXIU_FACE.CUOC_CAP.DESCRIPTION'),
                ratio: '1:5'
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('TAIXIU_FACE.CUOC_1SO.TITLE'),
        label: [
            {
                subIDFace: 'c1so',
                description: translate.instant('TAIXIU_FACE.CUOC_1SO.DESCRIPTION'),
                ratio: '1:1'
            }
        ]
    },
];

export const taixiuchanleFace = (translate: TranslateService) => [
    {
        title: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.TAI'),
        name: 'da',
        odds: '1:0.98',
        desc: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.TAI_DESC'),
        gridCol: 'col-6'
    },
    {
        title: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.XIU'),
        name: 'xiao',
        odds: '1:0.98',
        desc: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.XIU_DESC'),
        gridCol: 'col-6'
    },
    {
        notedGame: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.NOTED_GAME'),
        gridCol: 'col-12'
    },
    {
        title: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.LE'),
        name: 'dan',
        odds: '1:0.98',
        gridCol: 'col-6'
    },
    {
        title: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.CHAN'),
        name: 'shuang',
        odds: '1:0.98',
        gridCol: 'col-6'
    },
    {
        notedGame: translate.instant('TAIXIU_FACE.TAI_XIU_CHAN_LE.NOTED_GAME_CHAN_LE'),
        gridCol: 'col-12'
    }
];

export const bodoidongnhatFace = (translate: TranslateService) => [
    {
        titleType: translate.instant('TAIXIU_FACE.BO_DOI_DONG_NHAT.TITLE'),
        desc: translate.instant('TAIXIU_FACE.BO_DOI_DONG_NHAT.DESCRIPTION'),
        odds: '1:10',
        betsItem: [
            {
                name: 'duizi_11',
                xucxac: [
                    {color: 'xxRed',dotColor: ['psc']},
                    {color: 'xxRed',dotColor: ['psc']}
                ]
            },
            {
                name: 'duizi_22',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr', 'psbl']},
                    {color: 'xxBlack',dotColor: ['pstr', 'psbl']}
                ]
            },
            {
                name: 'duizi_33',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['psc', 'pstr', 'psbl']},
                    {color: 'xxBlack',dotColor: ['psc', 'pstr', 'psbl']}
                ]
            },
            {
                name: 'duizi_44',
                xucxac: [
                    {color: 'xxRed',dotColor: ['pstl', 'pstr', 'psbl', 'psbr']},
                    {color: 'xxRed',dotColor: ['pstl', 'pstr', 'psbl', 'psbr']}
                ]
            },
            {
                name: 'duizi_55',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstl', 'psc', 'pstr', 'psbl', 'psbr']},
                    {color: 'xxBlack',dotColor: ['pstl', 'psc', 'pstr', 'psbl', 'psbr']}
                ]
            },
            {
                name: 'duizi_66',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstl', 'pstr', 'pscl', 'pscr', 'psbr', 'psbl']},
                    {color: 'xxBlack',dotColor: ['pstl', 'pstr', 'pscl', 'pscr', 'psbr', 'psbl']}
                ]
            }
        ]
    }
];

export const bobadongnhatFace = (translate: TranslateService) => [
    {
        nameBlock: '',
        titleType: translate.instant('TAIXIU_FACE.BO_BA_DONG_NHAT.TITLE_SPECIFIC'),
        odds: '1:180',
        desc: translate.instant('TAIXIU_FACE.BO_BA_DONG_NHAT.DESCRIPTION_SPECIFIC'),
        betsItem: [
            {
                name: 'baozi_111',
                xucxac: [
                    {color: 'xxRed',dotColor: ['psc'], block: 1},
                    {color: 'xxRed',dotColor: ['psc'], block: 0},
                    {color: 'xxRed',dotColor: ['psc'], block: 0}
                ]
            },
            {
                name: 'baozi_222',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl'], block: 0}
                ]
            },
            {
                name: 'baozi_333',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl','psc'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','psc'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','psc'], block: 0}
                ]
            },
            {
                name: 'baozi_444',
                xucxac: [
                    {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr'], block: 1},
                    {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr'], block: 0},
                    {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr'], block: 0}
                ]
            },
            {
                name: 'baozi_555',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','psc'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','psc'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','psc'], block: 0}
                ]
            },
            {
                name: 'baozi_666',
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr'], block: 0}
                ]
            }
        ]
    },
    {
        nameBlock: 'baozi_nnn',
        titleType: translate.instant('TAIXIU_FACE.BO_BA_DONG_NHAT.TITLE_ANY'),
        odds: '1:30',
        desc: translate.instant('TAIXIU_FACE.BO_BA_DONG_NHAT.DESCRIPTION_ANY'),
        betsItem: [
            {
                xucxac: [
                    {color: 'xxRed',dotColor: ['psc'], block: 1},
                    {color: 'xxRed',dotColor: ['psc'], block: 0},
                    {color: 'xxRed',dotColor: ['psc'], block: 0}
                ]
            },
            {
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl'], block: 0}
                ]
            },
            {
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl','psc'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','psc'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','psc'], block: 0}
                ]
            },
            {
                xucxac: [
                    {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr'], block: 1},
                    {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr'], block: 0},
                    {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr'], block: 0}
                ]
            },
            {
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','psc'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','psc'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','psc'], block: 0}
                ]
            },
            {
                xucxac: [
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr'], block: 1},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr'], block: 0},
                    {color: 'xxBlack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr'], block: 0}
                ]
            }
        ]
    }
];

export const cuoctongFace = (translate: TranslateService) => ({
    title: translate.instant('TAIXIU_FACE.CUOC_TOAN.TITLE'),
    desc: translate.instant('TAIXIU_FACE.CUOC_TOAN.DESCRIPTION'),
    betsItem: [
        {num: 4,odds: '1:60',name:'hezhi_4'},
        {num: 5,odds: '1:30',name:'hezhi_5'},
        {num: 6,odds: '1:18',name:'hezhi_6'},
        {num: 7,odds: '1:12',name:'hezhi_7'},
        {num: 8,odds: '1:8',name:'hezhi_8'},
        {num: 9,odds: '1:6',name:'hezhi_9'},
        {num:10,odds: '1:6',name:'hezhi_10'},
        {num:11,odds: '1:6',name:'hezhi_11'},
        {num:12,odds: '1:6',name:'hezhi_12'},
        {num:13,odds: '1:8',name:'hezhi_13'},
        {num:14,odds: '1:12',name:'hezhi_14'},
        {num:15,odds: '1:18',name:'hezhi_15'},
        {num:16,odds: '1:30',name:'hezhi_16'},
        {num:17,odds: '1:60',name:'hezhi_17'}
    ]
});

export const cuoccapFace = (translate: TranslateService) => ({
    title: translate.instant('TAIXIU_FACE.CUOC_CAP.TITLE'),
    desc: translate.instant('TAIXIU_FACE.CUOC_CAP.DESCRIPTION'),
    betsBlock: [
        {
            odds: '1:5',
            itemsBlock: [
                {
                    name: 'erma_12',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['psc']},
                        {color: 'xxBack',dotColor: ['pstr','psbl']}
                    ]
                },
                {
                    name: 'erma_13',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['psc']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc']}
                    ]
                },
                {
                    name: 'erma_14',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['psc']},
                        {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_15',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['psc']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_16',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['psc']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr']}
                    ]
                }
            ]
        },
        {
            odds: '1:5',
            itemsBlock: [
                {
                    name: 'erma_23',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc']}
                    ]
                },
                {
                    name: 'erma_24',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl']},
                        {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_25',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_26',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr']}
                    ]
                }
            ]
        },
        {
            odds: '1:5',
            itemsBlock: [
                {
                    name: 'erma_34',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc']},
                        {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_35',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_36',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr']}
                    ]
                }
            ]
        },
        {
            odds: '1:5',
            itemsBlock: [
                {
                    name: 'erma_45',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc','pstl','psbr']}
                    ]
                },
                {
                    name: 'erma_46',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr']}
                    ]
                }
            ]
        },
        {
            odds: '1:5',
            itemsBlock: [
                {
                    name: 'erma_56',
                    xucxac: [
                        {color: 'xxBack',dotColor: ['pstr','psbl','psc','pstl','psbr']},
                        {color: 'xxBack',dotColor: ['pstr','psbl','pstl','psbr','pscl','pscr']}
                    ]
                }
            ]
        }
    ]
});

export const cuoc1SoFace = (translate: TranslateService) => ({
    title: translate.instant('TAIXIU_FACE.CUOC_1SO.TITLE'),
    desc: translate.instant('TAIXIU_FACE.CUOC_1SO.DESCRIPTION'),
    betsBlock: [
        {
            itemsBlock: [
                {
                    name: 'yima_1',
                    odds: '1:1',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['psc']},
                    ]
                },
                {
                    name: 'yima_2',
                    odds: '1:1',
                    xucxac: [
                        {color: 'xxBlack',dotColor: ['pstr','psbl']},
                    ]
                }
            ]
        },
        {
            itemsBlock: [
                {
                    name: 'yima_3',
                    odds: '1:1',
                    xucxac: [
                        {color: 'xxBlack',dotColor: ['psc','pstr','psbl']},
                    ]
                },
                {
                    name: 'yima_4',
                    odds: '1:1',
                    xucxac: [
                        {color: 'xxRed',dotColor: ['pstr','psbl','pstl','psbr']},
                    ]
                }
            ]
        },
        {
            itemsBlock: [
                {
                    name: 'yima_5',
                    odds: '1:1',
                    xucxac: [
                        {color: 'xxBlack',dotColor: ['psc','pstl','pstr','psbl','psbr']},
                    ]
                },
                {
                    name: 'yima_6',
                    odds: '1:1',
                    xucxac: [
                        {color: 'xxBlack',dotColor: ['pscl','pscr','pstl','pstr','psbl','psbr']},
                    ]
                }
            ]
        }
    ]
});


// WEBPACK FOOTER //
// ./src/+lotteryFace/taixiuFace.ts